import React, {Component} from "react";
import {renderRoutes} from "react-router-config";
import "../../index.css";

export default class AppRoot extends Component {
    render() {
        return (
            <React.Fragment>
                {renderRoutes(this.props.route.routes)}
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/js/components/AppRoot.js